<template>
    
        <v-avatar  :size="size" v-bind="$attrs" @click="click" :color="color" :dark="dark" :class="{'stamp': !empty && animate}" :style="style">
           <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-img  v-bind="attrs" @error="getDefault" v-on="on" v-if="stamp && stamp.stamp" :src="stamp.stamp" :style="getCssAngle()"></v-img>
              <v-img  v-bind="attrs" v-on="on" v-else :src="emptySrc" :style="getCssAngle()">
                  <div  v-bind="attrs" v-on="on" :class="`empty-text overline ${textColor}--text`" v-text="text"></div>
              </v-img>
              </template>
          <span>{{stamp.name}}</span>
        </v-tooltip>
        </v-avatar>
</template>
<script>

export default {
   props: {
    value: {
      type: Object,
      default: function () {
        return null
      },
    },
    text: {
      type: String,
      default: function () {
        return "eetplein.nl"
      },
    },
    size: {
        type: String,
      default: function () {
        return "20%"
      },
    },
    dark:{
        type: Boolean,
        default: function () {
            return false
        },
    },
    empty:{
        type: Boolean,
        default: function () {
            return false
        },
    },
    animate:{
        type: Boolean,
        default: function () {
            return true
        },
    },
   },
  data: () => ({
      max: 5,
      angle: 0
  }),
  computed: {
    emptySrc (){
      if (this.stamp) return "/img/stamp-empty-red.png"
       if (this.dark) return "/img/stamp-empty-white.png"
       return "/img/stamp-empty.png"
    },
    style (){
      const rndInt = this.animate ? Math.random() *1 : 0
      return  {
          'max-width':'100px',
          'animation-delay': rndInt + 's',
          '-webkit-animation-delay': rndInt + 's'
      }
   
    },
    color(){
        if (this.dark && this.stamp) return "white"
       return null
    },
    textColor(){
      if (this.stamp && !this.stamp.stamp) return "red"
        if (this.dark) return "white"
       return "grey"
    },
      stamp(){
          return this.value
      }
  },
  mounted () {
    this.angle = (Math.floor(Math.random() * 180) - 90) + 'deg'
  },
  methods: {
    getCssAngle(){
        
        return {
            "-webkit-transform": "rotate(" + this.angle + ")",
            "-moz-transform": "rotate(" + this.angle + ")",
            "-ms-transform": "rotate(" + this.angle + ")",
            "-o-transform": "rotate(" + this.angle + ")",
            "transform": "rotate(" + this.angle + ")"
        }
    },
    getDefault(e){
      console.log('error',e)
    },
    click(){
        this.$emit('click', this.stamp)
    }
  }
}

</script>
<style>
.empty-text{
    position: absolute;
    margin-top: 28%;
    width: 100%;
}
.ball {
  animation: 1s bounce ease infinite;
  animation-iteration-count: 1
}
@keyframes bounce {
  50% {
    transform: translateY(25px);
  }
}

.stamp{

  -webkit-animation-name: pulse;
  animation-name: pulse;
   -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  opacity: 0;
  -webkit-animation-fill-mode:forwards;
   animation-fill-mode:forwards;
}

@-webkit-keyframes pulse{
  0%{
    opacity: 0;
  }
  1%{
    opacity:.50;
    transform-origin: 50% 50%;
    transform: rotate(-2deg) scale(5);
    transition: all .3s cubic-bezier(0.6, 0.04, 0.98, 0.335);
  }
  100%{
    opacity:1;
    transform: rotate(-15deg) scale(1);
  }
}
</style>
